import { HStack, Box } from "@chakra-ui/react";


const BALL_SIZE = "6px";
const TypingIndicator = () => {
    return (
        <HStack w={'full'} py={0} px={0} justify={'flex-start'}>
            <Box maxW={'57%'} bg={'bg.chatBot'} borderRadius={12} borderBottomLeftRadius={0} py={3} px={4}>
                <HStack spacing={2} mt={1}>
                    <Box
                        w={BALL_SIZE}
                        h={BALL_SIZE}
                        bg="whiteAlpha.700"
                        borderRadius="50%"
                        animation={`bouncing 1.2s infinite ease-in-out`}
                        animationDelay="0s"
                    />
                    <Box
                        w={BALL_SIZE}
                        h={BALL_SIZE}
                        bg="whiteAlpha.700"
                        borderRadius="50%"
                        animation={`bouncing 1.2s infinite ease-in-out`}
                        animationDelay="0.2s"
                    />
                    <Box
                        w={BALL_SIZE}
                        h={BALL_SIZE}
                        bg="whiteAlpha.700"
                        borderRadius="50%"
                        animation={`bouncing 1.2s infinite ease-in-out`}
                        animationDelay="0.4s"
                    />
                </HStack>
            </Box>
        </HStack>
    );
};

export default TypingIndicator;
